import _ from 'lodash';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function OurCertifications({ data, id }) {
  const title = _.get(data, 'title', '');
  const isoLogo = _.get(data, 'isoLogo', '');
  const isoItems = _.get(data, 'isoItems', []);
  const awardsItems = _.get(data, 'awardsItems', []);

  return (
    <section id={id} className="bg-white pt-[50px] md:pt-[100px] pb-[50px]">
      <div className="max-w-[1370px] mx-auto relative px-6 flex flex-col gap-y-8 md:gap-y-[50px]">
        <h2 className="text-clamp22to30 !mb-0 text-center">{title}</h2>
        <div className="flex flex-col gap-y-8 md:gap-y-12">
          {_.isEmpty(isoItems) || (
            <div
              className="flex flex-col lg:flex-row gap-6 xl:gap-[30px] justify-center
            items-center">
              {_.isEmpty(isoLogo) || (
                <div className="ltr:lg:pr-[50px] rtl:lg:pl-[50px]">
                  <LazyLoadImage src={isoLogo.url} alt="Iso Logo" />
                </div>
              )}
              <div className='flex flex-row flex-wrap gap-5 md:gap-3 lg:gap-[30px] justify-center'>
                {_.map(isoItems, (isoItem, index) => (
                  <div
                    key={index}
                    className="md:border-r md:border-r-[#CCC] first:border-transparent
                    last:ltr:border-transparent max-w-[calc(50%-10px)] md:max-w-[190px]">
                    {_.isEmpty(isoItem.content.isoTitle) || (
                      <div className="flex flex-col gap-[10px] pr-2">
                        <span
                          className="text-clamp12to15 text-[#4A4A4A] font-medium leading-[133%]
                          font-DINMedium text-center ltr:md:text-left rtl:md:text-right">
                          {isoItem.content.isoNumber}
                        </span>
                        <h4
                          className="text-clamp12to16 font-normal leading-[140%] text-[#4A4A4A]
                          ltr:font-LibreBaskervilleRegular rtl:font-GEAwtarDWTCMedium text-center ltr:md:text-left
                          rtl:md:text-right">
                          {isoItem.content.isoTitle}
                        </h4>
                        <span
                          className="text-[#898989] leading-[142%] font-normal text-clamp12to14
                          font-DINRegular text-center ltr:md:text-left rtl:md:text-right">
                          {isoItem.content.isoDate}
                        </span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="bg-[#CCCCCC] w-full h-[1px]" />
          {_.isEmpty(awardsItems) || (
            <div
              className="flex flex-row flex-wrap xl:flex-nowrap gap-5 xl:gap-[30px]
            items-center justify-center md:items-start">
              {_.map(awardsItems, (awardsItem, index1) => (
                <div
                  className="w-[calc(50%-10px)] md:w-[calc(33.3333%-16px)] xl:w-[170px] flex
                  flex-col gap-y-[15px] items-center md:items-start"
                  key={index1}>
                  {_.isEmpty(awardsItem.content.certificateAwardLogo) || (
                    <LazyLoadImage
                      src={awardsItem.content.certificateAwardLogo.url}
                      alt={awardsItem.content.certificateAwardTitle}
                      className="w-[170px] h-[111px]"
                    />
                  )}
                  <div className="flex flex-col gap-y-[10px] items-center">
                    <span
                      className="text-clamp12to15 text-[#4A4A4A] font-medium leading-[133%]
                font-DINMedium text-center md:min-h-[20px]">
                      {awardsItem.content.certificateAwardTotal}
                    </span>
                    <h4
                      className="text-clamp12to16 font-normal leading-[140%] text-[#4A4A4A]
                ltr:font-LibreBaskervilleRegular rtl:font-GEAwtarDWTCMedium text-center">
                      {awardsItem.content.certificateAwardTitle}
                    </h4>
                    <span
                      className="text-[#898989] leading-[142%] font-normal text-clamp12to14
                font-DINRegula text-center">
                      {awardsItem.content.certificateAwardDate}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
